import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { PropertiesService } from 'src/app/_services/company/properties.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { LocationService } from 'src/app/_services/location.service';
import { NotificationService } from 'src/app/_services/notification.service';

@Component({
  selector: 'app-property',
  templateUrl: './property.component.html',
  styleUrls: ['./property.component.css']
})
export class PropertyComponent implements OnInit {

  countryList: any;
  stateList: any;
  cityList:any;

  constructor(private titleService: Title,
    public propertiesService: PropertiesService,
    private loading : LoadingService,
    private authService: AuthService,
    private router: Router,
    private locationService: LocationService,
    private notificationService: NotificationService) { 
      this.loading.spin$.next(true);
  }

  ngOnInit() {
    this.titleService.setTitle('Property Setting');
    this.onBindDropdown();
    this.loadPropertyData();
  }

  loadPropertyData(){
    this.propertiesService.get_our_property().subscribe(data=>{
      this.propertiesService.populateForm(data['data']);
    });
  }

  onBindDropdown(){
    this.locationService.get_country_list().subscribe(data=> {
      this.countryList = data['dataList'];
    });
    this.loading.spin$.next(false);
  }

  onBindStateDropdonw(country) {
    this.stateList = [];
    if(country.value){
      this.loading.spin$.next(true);
      let country_row = this.countryList.find(x=> x.name === country.value);
      if(country_row){
        let country_id = country_row.id;
        var result = this.locationService.get_states(country_id).subscribe(data=> {
          this.stateList = data['dataList'];
          this.loading.spin$.next(false);
        });
      }      
    }    
  }

  onBindCityDropdonw(state) {
    this.cityList = [];
    if(state.value){
      this.loading.spin$.next(true);
      let state_row = this.stateList.find(x=> x.name === state.value);
      if(state_row)
      {
        let state_id = state_row.id;
        var result = this.locationService.get_cities(state_id).subscribe(data=> {
          this.cityList = data['dataList'];
          this.loading.spin$.next(false);
        });
      }      
    }   
  }

  onSubmitForm(formData: any)
  {
    if (this.propertiesService.property_form.valid)
    {
      this.loading.spin$.next(true);
      this.propertiesService.update_property_details(formData).subscribe(data=>{
        if (data['status']) 
        {
          this.propertiesService.property_form.reset();
          this.authService.isLogin = true;
          this.notificationService.success('Property data added Successfully.'); 
          this.loading.spin$.next(false);
          this.router.navigateByUrl('/');
        } 
        else 
        {
          console.log(data);
          this.notificationService.error('Property data could not be updated, Try Again!');
          this.loading.spin$.next(false);
        }
      });
    }
  }

  

}
